import React, { useState } from 'react';
import { Button } from '../common/Button';
import { Gift, Share2, CheckCircle, MessageSquare } from 'lucide-react';
import { SUBSCRIPTION_PLANS } from '../../utils/constants/subscriptionPlans';
import { createAccount } from '../../services/auth/authService';
import { useNavigate } from 'react-router-dom';

export const TokenPlans = ({ onBack }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { tokenPacks } = SUBSCRIPTION_PLANS.PAY_AS_YOU_GO;

  const handleSelectPack = async (pack) => {
    setLoading(true);
    setError('');

    try {
      // Store selected pack for payment flow
      localStorage.setItem('selectedTokenPack', JSON.stringify(pack));
      navigate('/signup/tokens');
    } catch (err) {
      setError(err.message || 'Failed to select token pack');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-white mb-2">Token-Based Access</h2>
        <p className="text-gray-400">Pay only for what you need with our flexible token system</p>
      </div>

      {/* Token Packs */}
      <div className="grid gap-6 md:grid-cols-3">
        {tokenPacks.map(pack => (
          <div key={pack.id} className="bg-[#2A2B2E] p-6 rounded-lg border-2 border-gray-700">
            <h3 className="text-xl font-bold text-white mb-2">{pack.name}</h3>
            <div className="text-3xl font-bold text-white mb-4">
              ${pack.price}
              <span className="text-sm text-gray-400 ml-2">{pack.tokens} tokens</span>
            </div>
            <p className="text-gray-400 mb-6">{pack.description}</p>
            <Button
              onClick={() => handleSelectPack(pack)}
              className="w-full bg-red-600 hover:bg-red-700 text-white"
              loading={loading}
            >
              Select Pack
            </Button>
          </div>
        ))}
      </div>

      {/* Earn Free Tokens */}
      <div className="bg-[#2A2B2E] p-6 rounded-lg">
        <h3 className="text-xl font-bold text-white mb-4">Earn Free Tokens</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex items-start gap-3">
            <Share2 className="w-5 h-5 text-blue-400 shrink-0 mt-1" />
            <div>
              <p className="text-white font-medium">Share Surveys</p>
              <p className="text-sm text-gray-400">Share your route surveys</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <CheckCircle className="w-5 h-5 text-green-400 shrink-0 mt-1" />
            <div>
              <p className="text-white font-medium">Validate Data</p>
              <p className="text-sm text-gray-400">Help improve data accuracy</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Gift className="w-5 h-5 text-purple-400 shrink-0 mt-1" />
            <div>
              <p className="text-white font-medium">ML Training</p>
              <p className="text-sm text-gray-400">Participate in ML training</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MessageSquare className="w-5 h-5 text-yellow-400 shrink-0 mt-1" />
            <div>
              <p className="text-white font-medium">Feedback</p>
              <p className="text-sm text-gray-400">Provide feature feedback</p>
            </div>
          </div>
        </div>
      </div>

      <Button
        onClick={onBack}
        variant="default"
        className="w-full bg-gray-700 hover:bg-gray-600 text-white"
      >
        Back to Plans
      </Button>
    </div>
  );
};